import { GET_WALLET } from "../types";

export const wallet = (address) => {

    return {
        type: GET_WALLET,
        payload: address
    };
};